import { createFileRoute } from '@tanstack/react-router'
import { match } from 'ts-pattern'
import * as v from 'valibot'

import { AIFoundationEnding } from '@/poll/components/AIFoundation/AIFoundationEnding'
import { AIFoundationIntro } from '@/poll/components/AIFoundation/AIFoundationIntro'
import { PollForm } from '@/poll/components/PollForm/PollForm'
import { PollFormCompleted } from '@/poll/components/PollForm/PollFormCompleted'

export const Route = createFileRoute(
  '/_learning/poll/$pollId/$source/$sourceId',
)({
  params: {
    parse: (params) => ({
      ...params,
      source: v.parse(
        v.picklist(['course-start', 'course-end']),
        params.source,
      ),
    }),
  },
  component: RouteComponent,
})

export function RouteComponent() {
  const { pollId, source, sourceId } = Route.useParams()
  const navigate = Route.useNavigate()

  const handleClose = () =>
    navigate({
      to: '/discover/course-generic/$courseSlug',
      params: { courseSlug: sourceId },
    })

  return (
    <PollForm pollId={pollId} isOpen onClose={handleClose}>
      {match({ source, sourceId })
        .with({ source: 'course-start', sourceId: 'ai-fundamentals' }, () => (
          <AIFoundationIntro onContinue={handleClose} />
        ))
        .with({ source: 'course-end', sourceId: 'ai-fundamentals' }, () => (
          <AIFoundationEnding onContinue={handleClose} />
        ))
        .otherwise(() => (
          <PollFormCompleted onClose={handleClose} />
        ))}
    </PollForm>
  )
}
